import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { CurrentUserState } from '@core/state/shared';

@Directive({
  selector: '[appAllowAction]',
})
export class AllowActionDirective implements OnInit {
  @Input('appAllowAction') emails: string[];
  constructor(
    private currentUserState: CurrentUserState,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  public ngOnInit() {
    const allowAction = this.emails.includes(this.currentUserState.userEmail);
    if (allowAction) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
